<template>
  <div>
    <div id="print-report">
      <!-- Print Only -->
      <HeaderPrint />
      <!-- / Print Only -->

      <!-- Tabs -->
      <template>
        <v-btn-toggle mandatory style="width: 100%" class="mb-3 d-print-none">
          <v-btn
            large
            v-for="(tab, index) in tabItems"
            :key="index"
            style="flex: 1"
            @click="status = tab.value"
          >
            {{ tab.tabName }}
          </v-btn>
        </v-btn-toggle>
      </template>

      <!-- / Print Only -->
      <v-card>
        <div class="pa-2 d-print-none">
          <v-row no-gutters class="align-center">
            <v-col cols="6" md="5" class="pl-5">
              <v-btn
                small
                class="white black--text d-print-none"
                @click="$printReport()"
              >
                <v-icon small left>mdi-printer</v-icon>
                {{ $t("print") }}
              </v-btn>
            </v-col>

            <v-col
              cols="6"
              class="d-flex flex-row-reverse d-md-none d-lg-none d-xl-none"
            >
              <div>
                <v-btn-toggle dense>
                  <v-btn @click="breackPoint = 0" ref="desktopBreakpoint">
                    <v-icon>mdi-view-list</v-icon>
                  </v-btn>

                  <v-btn @click="breackPoint = 'xs'" ref="mobileBreakpoint">
                    <v-icon>mdi-view-grid</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </div>
            </v-col>
            <v-col cols="12" md="3" class="mr-5">
              <v-select
                v-show="this.operatorCredit > 0"
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="selectedOption"
                :items="options"
                item-text="label"
                item-value="value"
                :label="$t('TypeBet')"
                @change="onBalanceTypeChange"
                outlined
                dense
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field
                :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
                v-model="search"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :items="data"
          :search="search"
          :items-per-page="10"
          item-class="text--red"
          :mobile-breakpoint="breackPoint"
          :footer-props="{
            'items-per-page-text': this.$t('rowsPerPage'),
          }"
        >
          <template v-slot:item.id_match="{ item }">
            <v-btn @click="$copy(item.id_match)" x-small>
              {{ item.id_match }}
            </v-btn>
          </template>
          <template v-slot:item.action="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" small @click="showDialog(item)">
                  <v-icon>mdi-chart-bar</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("graphic") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>

        <template>
          <v-dialog v-model="dialog" persistent fullscreen>
            <v-toolbar>
              <v-toolbar-title>
                {{ event.description }}
                <div class="caption pt-1">{{ event.scheduled }}</div>
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click="closeDialog()"
                ><v-icon>mdi-close</v-icon></v-btn
              >
            </v-toolbar>

            <v-card>
              <BarChart
                :simple="dataBarChart.simple"
                :multiple="dataBarChart.multiple"
                :lost="dataBarChart.lost"
                :labels="dataBarChart.labels"
                :max="maxBarChart"
              />
            </v-card>
          </v-dialog>
        </template>
      </v-card>
    </div>
  </div>
</template>
<script>
import BarChart from "@/components/Charts/BarChart";
import HeaderPrint from "@/components/common/header-print";
export default {
  name: "collaborator-reports",
  components: {
    BarChart,
    HeaderPrint,
  },
  data: () => ({
    search: "",
    data: [],
    breackPoint: 0,
    status: "new",
    dataBarChart: {
      simple: [],
      multiple: [],
      labels: [],
    },
    maxBarChart: null,
    event: {
      description: "",
      scheduled: "",
    },
    selectedOption: "",
    options: [],
    operatorRetail: "",
    operatorCredit: "",
  }),

  created() {
    this.$nextTick(() => {
      const ref = this.$vuetify.breakpoint.mobile
        ? "mobileBreakpoint"
        : "desktopBreakpoint";

      this.$refs[ref].$el.click();
    });

    this.getData();
    this.operatorRetail = localStorage.getItem("operator-retail");
    this.operatorCredit = localStorage.getItem("operator-credit");
    this.betTypes();
  },

  computed: {
    headers() {
      return [
        { text: this.$t("code"), value: "id_match" },
        { text: this.$t("championship"), value: "tournaments_name" },
        { text: this.$t("event"), value: "description" },
        { text: this.$t("date"), value: "scheduled" },
        // { text: "Canceladas", value: "" },
        { text: this.$t("nOfBets"), value: "qtd_bets" },
        { text: this.$t("simple"), value: "sum_simple" },
        { text: this.$t("multiples"), value: "sum_multiple" },
        { text: this.$t("lost"), value: "sum_lost" },
        ...(this.canListGraphicEvent
          ? [{ text: this.$t("graphic"), value: "action" }]
          : []),
      ];
    },
    tabItems() {
      return [
        { tabName: this.$t("news"), value: "new" },
        { tabName: this.$t("olds"), value: "old" },
      ];
    },
    dialog() {
      return this.$store.state.showDialog;
    },
    canListGraphicEvent() {
      return this.$permission("72");
    },
  },

  watch: {
    status(val) {
      val && this.getData();
    },
    dialog(val) {
      !val && this.closeDialog();
    },
  },

  methods: {
    betTypes() {
      if (this.operatorCredit == 0) {
        this.options.push({ label: this.$t("allBets"), value: "" });
      }
      if (this.operatorCredit == 1) {
        this.options.push(
          { label: this.$t("allBets"), value: "" },
          { label: this.$t("agentBet"), value: 0 },
          { label: this.$t("onlineBetting"), value: 1 }
        );
      }
      if (this.operatorCredit == 2 && this.operatorRetail == 0) {
        this.options.push(
          { label: this.$t("allBets"), value: "" },
          { label: this.$t("bonusBet"), value: 2 },
          { label: this.$t("onlineBetting"), value: 1 }
        );
      }
      if (this.operatorCredit == 2 && this.operatorRetail > 0) {
        this.options.push(
          { label: this.$t("allBets"), value: "" },
          { label: this.$t("bonusBet"), value: 2 },
          { label: this.$t("onlineBetting"), value: 1 },
          { label: this.$t("agentBet"), value: 0 }
        );
      }
    },
    onBalanceTypeChange() {
      this.getData();
    },
    async getData() {
      const request = await this.$request.post(
        "/colab/report/betsEventsSales",
        { status: this.status, debit_credit: this.selectedOption }
      );
      this.data = request.dados;
      this.data.forEach((item) => {
        item.scheduled = new Date(
          item.scheduled.replace(" ", "T")
        ).toLocaleString();
      });
    },

    async showDialog(item) {
      const request = await this.$request.post("/colab/report/eventSales", {
        id_match: item.id_match,
        debit_credit: this.selectedOption,
      });
      // Data evetns
      this.event = {
        description: item.description,
        scheduled: item.scheduled,
      };

      // Reset
      this.dataBarChart.labels = [];
      this.dataBarChart.simple = [];
      this.dataBarChart.multiple = [];
      this.dataBarChart.lost = [];

      // Build data Chart
      request.dados.forEach((item) => {
        this.dataBarChart.labels.push(
          this.$infoTable.outcomes(item.id_outcome).name_outcome
        );
        this.dataBarChart.simple.push(Number(item.sum_simple));
        this.dataBarChart.multiple.push(Number(item.sum_multiple));
        this.dataBarChart.lost.push(Number(item.sum_lost));
      });

      const max =
        Math.max.apply(null, this.dataBarChart.simple) >
        Math.max.apply(null, this.dataBarChart.multiple)
          ? Math.max.apply(null, this.dataBarChart.simple)
          : Math.max.apply(null, this.dataBarChart.multiple);

      this.maxBarChart = max + 20;

      // Show dialog
      this.$store.commit("showDialog", true);
    },

    closeDialog() {
      this.$store.commit("showDialog", false);
    },
  },
};
</script>
